import React from 'react';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import { Link } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react';
import { ctaSectionData } from '../../data';
import { ctaSectionDataArabic } from '../../data/indexArabic';
import { useAuth } from '../../store/auth';

const CtaSection = () => {
  // Note: There might be a logic error here. It should likely be:
  // const data = isArabic ? ctaSectionDataArabic : ctaSectionData;
  const { isArabic } = useAuth();
  const data = isArabic ? ctaSectionData : ctaSectionDataArabic;

  const highlightedTextStyle = {
    color: '#766df4', // A strong, readable orange for light backgrounds
  };

  return (
    <React.Fragment>
      {data && (
        <Container>
          {/* Changed background to bg-light and removed overlay */}
          <Card className="bg-light shadow rounded-3 overflow-hidden border-0">
            <CardBody className="py-5 position-relative">
              <Row className="align-items-center">
                <Col lg="8" md="7">
                  <div className="text-center text-md-start">
                    {/* Changed heading text to dark */}
                    <h4 className="text-dark title-dark mb-3">
                      {data?.titles?.map((ele, index) => (
                        <span
                          key={index}
                          // Applied inline style for better highlight color on light bg
                          style={ele.highlight ? highlightedTextStyle : {}}
                        >
                          {ele.breakPoint && <br />}
                          {ele.title}
                        </span>
                      ))}
                    </h4>
                    {/* Changed paragraph text to muted for secondary text color */}
                    <p className="text-muted para-dark mb-0">
                      {data?.description?.map((ele, index) => (
                        <span
                          className={ele.highlight ? 'fw-bold' : ''}
                          // Applied same inline style for consistency
                          style={ele.highlight ? highlightedTextStyle : {}}
                          key={index}
                        >
                          {ele.content}
                        </span>
                      ))}
                    </p>
                  </div>
                </Col>
                <Col lg="4" md="5" className="mt-4 mt-md-0">
                  <div className="text-center text-md-end">
                    {/* Changed primary button to a standard 'btn-primary' */}
                    <Link to={data?.primaryButton?.link || '/contact-us'} className="btn btn-primary btn-pills mb-2">
                      <FeatherIcon icon={data?.primaryButton?.icon || 'phone'} className="me-2" size={16} />
                      {data?.primaryButton?.text || 'Get Started'}
                    </Link>
                    {data?.secondaryButton && (
                      // Changed outline button to 'dark' to be visible on light bg
                      <Link to={data.secondaryButton.link} className="btn btn-outline-dark btn-pills ms-2">
                        <FeatherIcon icon={data.secondaryButton.icon} className="me-2" size={16} />
                        {data.secondaryButton.text}
                      </Link>
                    )}
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Container>
      )}
    </React.Fragment>
  );
};

export default CtaSection;